import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppId, AppThunkAPIType, } from "../../app/appTypes";
import { getWithAuth, postWithAuth } from "../../http";
import { Urs, UrsHeader } from "./UrsSlice";


export const loadDynamicUrsList = createAsyncThunk<UrsHeader[], void, AppThunkAPIType>(
    "dynamicUrs/load",
    async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({ url: `api/dynamic-urs` }));
        const { payload } = result;

        if (getWithAuth.fulfilled.match(result)) {
            return payload as UrsHeader[];
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" });
        }
    }
);

export interface CreateDynamicURSPayload {
    createFrom: string
    numberingMode: string
    deviceTypeId: AppId
    ursNumber: string
    title: string
    structureTemplateId: AppId | undefined
    requirementPackageId: AppId | undefined
    ursId: AppId | undefined
    purpose: string
    area: string
    description: string
    language: string
    processId: string | null
}

export const createDynamicURS = createAsyncThunk<Urs, CreateDynamicURSPayload, AppThunkAPIType>("urs/create", async (data, {
    dispatch,
    rejectWithValue,
}) => {
    const result = await dispatch(postWithAuth({
        url: "api/dynamic-urs",
        payload: data,
    }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

